import { render, staticRenderFns } from "./suspension.vue?vue&type=template&id=5785ad69"
import script from "./suspension.vue?vue&type=script&lang=js"
export * from "./suspension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports